import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LogService } from "./core/services/log.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  constructor(
    private logger: LogService,
    private titleService: Title
  ) {
    this.titleService.setTitle("Online Merchant Management");
    this.logger.log("AppComponent Load.");
  }

  ngOnInit(): void {
    // $("div.loading").css("display", "block");
  }
}
